import {
    SortDirection,
    ProductSortProperty,
    parseIndexSelectorParams,
} from '@app-lib/search-index.lib'

import { ProductSortInput } from '@app-domains/meilisearch/types/product-search.types'

const SORT_ATTRIBUTE_MAP: Record<ProductSortProperty, (isNl: boolean) => string> = {
    [ProductSortProperty.Price]: (isNl) => isNl
        ? 'suggestedRetailPriceNlInFloat'
        : 'suggestedRetailPriceIseInFloat',
    [ProductSortProperty.ProductCode]: () => 'codeLocal',
    [ProductSortProperty.Range]: () => 'range',
    [ProductSortProperty.Name]: () => 'title',
    [ProductSortProperty.CreationDate]: () => 'createdAt',
}

export function indexNameToSort(indexName: string, isNlMarket: boolean): ProductSortInput[] {
    const { sorting } = parseIndexSelectorParams(indexName)

    if (sorting === null) {
        return [{ attribute: 'plpSorting', direction: 'desc' }]
    }

    const attribute = SORT_ATTRIBUTE_MAP[sorting.property](isNlMarket)
    const direction = sorting.direction === SortDirection.Ascending ? 'asc' : 'desc'

    return [{ attribute, direction }]
}
